/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/time';
import '../common/token';
import '../bills/tender';
import '../common/instrument';
import '../common/location';
import '../simple_instrument_store/api';
import '../rolodexdiscovery/filters';
import '../bills/employee';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "rolodex": {
        "nested": {
          "RolodexError": {
            "fields": {
              "code": {
                "type": ".squareup.rolodex.RolodexError.Code",
                "id": 1,
                "rule": "optional"
              },
              "debugText": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Code": {
                "values": {
                  "NONE": 0,
                  "NOT_FOUND": 1,
                  "SUBSCRIPTION_REQUIRED": 2
                }
              }
            }
          },
          "ContactSource": {
            "values": {
              "IMPORT": 0,
              "MANUAL": 1,
              "PAYMENTS_FEED": 2,
              "POINT_OF_SALE": 3,
              "INVOICE": 4,
              "MARKETING": 5,
              "MARKETING_FEED": 13,
              "EXTERNAL_PLATFORM": 6,
              "FEEDBACK": 7,
              "ONLINE_STORE": 8,
              "THIRD_PARTY_IMPORT": 9,
              "RETAIL_POS": 10,
              "MERGE": 11,
              "APPOINTMENTS": 12,
              "LOYALTY": 14,
              "INSTRUMENTS_FEED": 15,
              "NOTE": 16,
              "COUPON_ISSUE_FEED": 17,
              "COUPON_REDEMPTION_FEED": 18,
              "EMAIL_COLLECTION": 19,
              "GIFTCARD": 20,
              "RECOVERED_FROM_DELETED": 21,
              "TERMINAL": 22,
              "RECOVERED_FROM_MERGED": 23,
              "CONTRACTS": 24,
              "AUTOMATIC_MERGE": 25
            }
          },
          "AudienceType": {
            "values": {
              "SKIPPED": 0,
              "LOYAL": 1,
              "CASUAL": 2,
              "CHURN_RISK": 3,
              "TWO_VISITS_SIX_MONTHS": 4,
              "SOCIAL": 5,
              "NO_GROUP_ASSIGNED": 6,
              "ONLINE_STORE_AUDIENCE": 7,
              "REACHABLE": 8,
              "RECENT_FEEDBACK_POSITIVE": 9,
              "RECENT_FEEDBACK_NEGATIVE": 10,
              "RECENT_FEEDBACK_ANY": 11,
              "CARDS_ON_FILE": 12,
              "ALL_EMAILS": 13,
              "LOYALTY_ALL": 14,
              "LOYALTY_CLOSE_TO_REWARD": 15,
              "GROUP_V2_SMART": 16
            }
          },
          "CustomerType": {
            "values": {
              "REGULAR": 0,
              "ALIAS": 1,
              "CASH_PROFILE": 2
            }
          },
          "Comparator": {
            "values": {
              "EQUAL": 1,
              "GREATER_THAN": 2,
              "GREATER_THAN_OR_EQUAL_TO": 3,
              "LESS_THAN": 4,
              "LESS_THAN_OR_EQUAL_TO": 5
            }
          },
          "BuyerFrequencyData": {
            "fields": {
              "minFrequency": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "maxFrequency": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "buyerCount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "meanGpv": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "BuyerSummary": {
            "fields": {
              "transactionCount": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "firstVisit": {
                "type": ".squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "lastVisit": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "averageTransactionFrequencyMillis": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "localizedTransactionFrequencyDescription": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "totalGpv": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "firstVisitUnitToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "lastVisitUnitToken": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "visitedUnitTokens": {
                "type": "string",
                "id": 9,
                "rule": "repeated"
              }
            }
          },
          "Payment": {
            "fields": {
              "paymentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "contactToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              },
              "nameOnCard": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "EmailSubscriptions": {
            "fields": {
              "canReceiveDirectMessaging": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "Contact": {
            "fields": {
              "contactToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "authorToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "displayName": {
                "type": "string",
                "id": 23,
                "rule": "optional"
              },
              "createdAtMs": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "updatedAtMs": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "deleted": {
                "type": "bool",
                "id": 36,
                "rule": "optional"
              },
              "mergedToContactToken": {
                "type": "string",
                "id": 38,
                "rule": "optional"
              },
              "automatic": {
                "type": "bool",
                "id": 21,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "source": {
                "type": ".squareup.rolodex.ContactSource",
                "id": 22,
                "rule": "optional"
              },
              "sourceLabel": {
                "type": "string",
                "id": 49,
                "rule": "optional"
              },
              "emailable": {
                "type": "bool",
                "id": 28,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "profile": {
                "type": ".squareup.rolodex.Profile",
                "id": 31,
                "rule": "optional"
              },
              "schemaVersion": {
                "type": "string",
                "id": 41,
                "rule": "optional"
              },
              "attributes": {
                "type": ".squareup.rolodex.AttributeSchema.Attribute",
                "id": 42,
                "rule": "repeated"
              },
              "applicationFields": {
                "type": ".squareup.rolodex.ApplicationFields",
                "id": 37,
                "rule": "optional"
              },
              "emailId": {
                "type": "int64",
                "id": 29,
                "rule": "optional"
              },
              "phoneId": {
                "type": "int64",
                "id": 30,
                "rule": "optional"
              },
              "privateEmailId": {
                "type": "int64",
                "id": 33,
                "rule": "optional"
              },
              "privatePhoneId": {
                "type": "int64",
                "id": 34,
                "rule": "optional"
              },
              "group": {
                "type": ".squareup.rolodex.Group",
                "id": 19,
                "rule": "repeated"
              },
              "buyerSummary": {
                "type": ".squareup.rolodex.BuyerSummary",
                "id": 26,
                "rule": "optional"
              },
              "instrumentsOnFile": {
                "type": ".squareup.rolodex.InstrumentsOnFile",
                "id": 32,
                "rule": "optional"
              },
              "linkedPaymentCards": {
                "type": ".squareup.rolodex.LinkedPaymentCards",
                "id": 35,
                "rule": "optional"
              },
              "emailUnsubscribe": {
                "type": "bool",
                "id": 39,
                "rule": "optional"
              },
              "payments": {
                "type": ".squareup.rolodex.Payment",
                "id": 40,
                "rule": "repeated"
              },
              "totalDuplicateCount": {
                "type": "int32",
                "id": 43,
                "rule": "optional"
              },
              "obfuscatedIdentifiers": {
                "type": ".squareup.rolodex.ObfuscatedIdentifiers",
                "id": 44,
                "rule": "optional"
              },
              "notes": {
                "type": ".squareup.rolodex.Note",
                "id": 45,
                "rule": "repeated"
              },
              "emailSubscriptions": {
                "type": ".squareup.rolodex.EmailSubscriptions",
                "id": 46,
                "rule": "optional"
              },
              "attachments": {
                "type": ".squareup.rolodex.Attachment",
                "id": 47,
                "rule": "repeated"
              },
              "appFields": {
                "type": ".squareup.rolodex.AppField",
                "id": 48,
                "rule": "repeated"
              },
              "isHidden": {
                "type": "bool",
                "id": 50,
                "rule": "optional"
              },
              "concurrencyVersion": {
                "type": "int64",
                "id": 51,
                "rule": "optional"
              },
              "version": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "referenceId": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "givenName": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "surname": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "nickname": {
                "type": "string",
                "id": 27,
                "rule": "optional"
              },
              "companyName": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "birthday": {
                "type": ".squareup.common.time.YearMonthDay",
                "id": 12,
                "rule": "optional"
              },
              "timeZone": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "memo": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "email": {
                "type": ".squareup.rolodex.Email",
                "id": 15,
                "rule": "repeated"
              },
              "phone": {
                "type": ".squareup.rolodex.Phone",
                "id": 16,
                "rule": "repeated"
              },
              "address": {
                "type": ".squareup.rolodex.Address",
                "id": 17,
                "rule": "repeated"
              },
              "otherName": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "customerType": {
                "type": ".squareup.rolodex.CustomerType",
                "id": 52,
                "rule": "optional",
                "options": {
                  "default": "REGULAR"
                }
              },
              "linkedContacts": {
                "type": ".squareup.rolodex.Contact",
                "id": 53,
                "rule": "repeated"
              },
              "buyerId": {
                "type": "string",
                "id": 54,
                "rule": "optional"
              }
            }
          },
          "ContactOptions": {
            "fields": {
              "includeInstrumentsOnFile": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "includeGroups": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "includeBuyerSummary": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "includeEmailableViaMarketing": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "includeLinkedPaymentCards": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "includeApplicationFields": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "buyerSummaryBeginTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 7,
                "rule": "optional"
              },
              "buyerSummaryEndTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              },
              "includeDeleted": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "scrubInvalidEmailPhone": {
                "type": "bool",
                "id": 10,
                "rule": "optional"
              },
              "includeEmailUnsubscribe": {
                "type": "bool",
                "id": 11,
                "rule": "optional"
              },
              "includePayments": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "includeAttributes": {
                "type": "bool",
                "id": 13,
                "rule": "optional"
              },
              "includeTotalDuplicateCount": {
                "type": "bool",
                "id": 14,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "includeObfuscatedIdentifiers": {
                "type": "bool",
                "id": 15,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "includeReminders": {
                "type": "bool",
                "id": 16,
                "rule": "optional"
              },
              "includeEmailSubscriptions": {
                "type": "bool",
                "id": 17,
                "rule": "optional"
              },
              "includeAttachments": {
                "type": "bool",
                "id": 18,
                "rule": "optional"
              },
              "appIds": {
                "type": "string",
                "id": 19,
                "rule": "repeated"
              },
              "requestedGroupTypes": {
                "type": ".squareup.rolodex.RequestedGroupType",
                "id": 20,
                "rule": "optional"
              },
              "fetchInstrumentsOnFileWithOptimization": {
                "type": "bool",
                "id": 21,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "allowMergeRetrieval": {
                "type": "bool",
                "id": 22,
                "rule": "optional",
                "options": {
                  "default": true
                }
              }
            }
          },
          "ContactPaymentPair": {
            "fields": {
              "paymentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "contact": {
                "type": ".squareup.rolodex.Contact",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Group": {
            "fields": {
              "groupToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "audienceType": {
                "type": ".squareup.rolodex.AudienceType",
                "id": 5,
                "rule": "optional"
              },
              "groupType": {
                "type": ".squareup.rolodex.GroupType",
                "id": 6,
                "rule": "optional"
              },
              "audienceParams": {
                "type": ".squareup.rolodex.AudienceParams",
                "id": 15,
                "rule": "optional"
              },
              "needsRefresh": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "numCustomers": {
                "type": "int64",
                "id": 12,
                "rule": "optional"
              },
              "numEmailable": {
                "type": "int64",
                "id": 13,
                "rule": "optional"
              },
              "numManual": {
                "type": "int64",
                "id": 17,
                "rule": "optional"
              },
              "externalImportInProgress": {
                "type": "bool",
                "id": 14,
                "rule": "optional"
              },
              "filters": {
                "type": ".squareup.rolodex.Filter",
                "id": 18,
                "rule": "repeated"
              },
              "hidden": {
                "type": "bool",
                "id": 19,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 20,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 21,
                "rule": "optional"
              },
              "hasAdvancedFilters": {
                "type": "bool",
                "id": 22,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "contactCount": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "customerCount": {
                "type": "int64",
                "id": 7,
                "rule": "optional"
              },
              "emailableCount": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "numContacts": {
                "type": "int64",
                "id": 11,
                "rule": "optional"
              },
              "numMembers": {
                "type": "int64",
                "id": 10,
                "rule": "optional"
              },
              "numAutomatic": {
                "type": "int64",
                "id": 16,
                "rule": "optional"
              }
            }
          },
          "GroupV2": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.GroupV2.Type",
                "id": 8,
                "rule": "optional"
              },
              "groupTokenPair": {
                "type": ".squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "filters": {
                "type": ".squareup.rolodex.Filter",
                "id": 4,
                "rule": "repeated"
              },
              "hidden": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "numCustomers": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "numEmailable": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "numManual": {
                "type": "int32",
                "id": 7,
                "rule": "optional"
              },
              "hasAdvancedFilters": {
                "type": "bool",
                "id": 10,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "INVALID": 0,
                  "MANUAL": 1,
                  "SMART": 2
                }
              }
            }
          },
          "GroupOptions": {
            "fields": {
              "includeCounts": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "includeExternalImportInProgress": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "shouldSetAudienceParams": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "shouldIgnoreNameChangesOnCreate": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "requestedGroupTypes": {
                "type": ".squareup.rolodex.RequestedGroupType",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "GroupType": {
            "values": {
              "MANUAL_GROUP": 0,
              "AUDIENCE_GROUP": 1,
              "INTERNAL_GROUP": 2
            }
          },
          "RequestedGroupType": {
            "fields": {
              "includeSmartGroup": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "includeManualAndAudienceGroup": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "includeHiddenSmartGroup": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "includeHiddenManualGroup": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "AudienceParams": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.AudienceType",
                "id": 1,
                "rule": "optional"
              },
              "casualExactlyXVisits": {
                "type": "int64",
                "id": 100,
                "rule": "optional"
              },
              "casualInYDays": {
                "type": "int64",
                "id": 101,
                "rule": "optional"
              },
              "loyalGteXVisits": {
                "type": "int64",
                "id": 300,
                "rule": "optional"
              },
              "loyalInYDays": {
                "type": "int64",
                "id": 301,
                "rule": "optional"
              },
              "loyalLastVisitLtZDaysAgo": {
                "type": "int64",
                "id": 302,
                "rule": "optional"
              },
              "churnRiskGteXVisits": {
                "type": "int64",
                "id": 200,
                "rule": "optional"
              },
              "churnRiskInYDays": {
                "type": "int64",
                "id": 201,
                "rule": "optional"
              },
              "churnRiskLastVisitGtZDaysAgo": {
                "type": "int64",
                "id": 202,
                "rule": "optional"
              }
            }
          },
          "LinkedPaymentCard": {
            "fields": {
              "paymentCardToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "cardType": {
                "type": ".squareup.bills.CardTender.Card.Brand",
                "id": 2,
                "rule": "optional"
              },
              "panSuffix": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "nameOnCard": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "transactionCount": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "paymentCardId": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "contact": {
                "type": ".squareup.rolodex.Contact",
                "id": 7,
                "rule": "optional"
              },
              "cardBrand": {
                "type": ".squareup.common.instrument.InstrumentType",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "LinkedPaymentCards": {
            "fields": {
              "cards": {
                "type": ".squareup.rolodex.LinkedPaymentCard",
                "id": 1,
                "rule": "repeated"
              },
              "error": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "MerchantOptions": {
            "fields": {
              "includeCounts": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "includeBusinessCounts": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "includeSubscription": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "includeHasDuplicates": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "includeReachableCount": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "includeDefaultAttributeDefinitions": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "Merchant": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "totalContactCount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "smartContactCount": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "desiredTier": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "customersCount": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "contactsCount": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "instantProfileCustomersCount": {
                "type": "int32",
                "id": 7,
                "rule": "optional"
              },
              "instantProfileContactsCount": {
                "type": "int32",
                "id": 8,
                "rule": "optional"
              },
              "manualCustomersCount": {
                "type": "int32",
                "id": 9,
                "rule": "optional"
              },
              "flags": {
                "type": "string",
                "id": 10,
                "rule": "repeated"
              },
              "needsRefresh": {
                "type": "bool",
                "id": 11,
                "rule": "optional"
              },
              "activeSubscription": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "hasDuplicates": {
                "type": "bool",
                "id": 13,
                "rule": "optional"
              },
              "smartGroupSettings": {
                "type": ".squareup.rolodex.SmartGroupSettings",
                "id": 14,
                "rule": "optional"
              },
              "isMultiUnit": {
                "type": "bool",
                "id": 15,
                "rule": "optional"
              },
              "currentSchema": {
                "type": ".squareup.rolodex.AttributeSchema",
                "id": 16,
                "rule": "optional"
              },
              "merchantSettings": {
                "type": ".squareup.rolodex.MerchantSettings",
                "id": 17,
                "rule": "optional"
              }
            }
          },
          "SmartGroupSettings": {
            "fields": {
              "minVisits": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "maxDays": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "loyalMinVisits": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "loyalMaxDays": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "loyalLastVisitInDaysAgo": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "MerchantSettings": {
            "fields": {
              "enableAutomaticContactCreation": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "supportPhoneticNames": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "hasSeenInstantProfilesIntroduction": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "supportEmailMarketingOptIn": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "Profile": {
            "fields": {
              "version": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "referenceId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "givenName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "surname": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "nickname": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "companyName": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "birthday": {
                "type": ".squareup.common.time.YearMonthDay",
                "id": 7,
                "rule": "optional"
              },
              "timeZone": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "memo": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "emailAddress": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "phoneNumber": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "address": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 12,
                "rule": "optional"
              },
              "taxId": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "cashTag": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "phoneticGivenName": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "phoneticSurname": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              }
            }
          },
          "ApplicationFields": {
            "fields": {
              "appointmentsEmailNotificationSetting": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "appointmentsPhoneNotificationSetting": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ObfuscatedIdentifiers": {
            "fields": {
              "obfuscatedEmailAddress": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "obfuscatedPhoneNumber": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "obfuscatedAddress": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "HeaderType": {
            "values": {
              "UNKNOWN": 0,
              "GIVEN_NAME": 1,
              "SURNAME": 2,
              "COMPANY_NAME": 3,
              "EMAIL": 4,
              "PHONE": 5,
              "TIME_ZONE": 6,
              "STREET_ONE": 7,
              "STREET_TWO": 8,
              "CITY": 9,
              "STATE": 10,
              "ZIP": 11,
              "REFERENCE_ID": 12,
              "ADD_AS_NOTE": 13,
              "CONTACT_TOKEN": 14,
              "CUSTOM_ATTRIBUTE": 15,
              "BIRTHDAY": 16,
              "DO_NOT_IMPORT": 17,
              "EMAIL_SUBSCRIPTION_STATUS": 18,
              "PHONETIC_GIVEN_NAME": 19,
              "PHONETIC_SURNAME": 20,
              "TEXT_SUBSCRIPTION_STATUS": 21,
              "LOYALTY_INITIAL_POINTS_BALANCE": 22
            }
          },
          "HeaderDefinition": {
            "fields": {
              "columnIndex": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "label": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "headerType": {
                "type": ".squareup.rolodex.HeaderType",
                "id": 3,
                "rule": "optional"
              },
              "example": {
                "type": "string",
                "id": 4,
                "rule": "repeated"
              },
              "customAttributeKey": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "customAttributeType": {
                "type": ".squareup.rolodex.HeaderDefinition.CustomAttributeType",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "CustomAttributeType": {
                "values": {
                  "UNKNOWN": 0,
                  "NUMBER": 1,
                  "BOOLEAN": 2,
                  "TEXT": 3,
                  "ENUM": 4,
                  "EMAIL": 5,
                  "PHONE": 6,
                  "ADDRESS_STREET_ONE": 7,
                  "ADDRESS_STREET_TWO": 8,
                  "ADDRESS_CITY": 9,
                  "ADDRESS_STATE": 10,
                  "ADDRESS_ZIP": 11,
                  "DATE": 12
                }
              }
            }
          },
          "CSVMessage": {
            "fields": {
              "type": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "line": {
                "type": "int64",
                "id": 2,
                "rule": "optional"
              },
              "column": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "message": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "fieldValue": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "HeaderSpec": {
            "fields": {
              "headerInFirstRow": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "parseError": {
                "type": ".squareup.rolodex.CSVMessage",
                "id": 2,
                "rule": "optional"
              },
              "definition": {
                "type": ".squareup.rolodex.HeaderDefinition",
                "id": 3,
                "rule": "repeated"
              },
              "definitionsToCreate": {
                "type": ".squareup.rolodex.HeaderDefinition",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "CSVImportState": {
            "values": {
              "IN_PROGRESS": 3,
              "COMPLETE": 1,
              "ERRORED": 2
            }
          },
          "CSVImportStatus": {
            "fields": {
              "uploadId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.rolodex.CSVImportState",
                "id": 2,
                "rule": "optional"
              },
              "error": {
                "type": ".squareup.rolodex.CSVMessage",
                "id": 5,
                "rule": "repeated"
              },
              "group": {
                "type": ".squareup.rolodex.Group",
                "id": 7,
                "rule": "optional"
              },
              "addedCount": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "processedRowsCount": {
                "type": "int64",
                "id": 10,
                "rule": "optional"
              },
              "importProgress": {
                "type": "double",
                "id": 11,
                "rule": "optional"
              },
              "rowsNotImportedCount": {
                "type": "int64",
                "id": 12,
                "rule": "optional"
              },
              "partiallyImportedCount": {
                "type": "int64",
                "id": 13,
                "rule": "optional"
              },
              "newContactsCount": {
                "type": "int64",
                "id": 14,
                "rule": "optional"
              },
              "updatedContactsCount": {
                "type": "int64",
                "id": 15,
                "rule": "optional"
              },
              "updatedRows": {
                "type": "int64",
                "id": 16,
                "rule": "repeated"
              },
              "bulkActionToken": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "totalErrorCount": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              },
              "totalNoticeCount": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "notice": {
                "type": ".squareup.rolodex.CSVMessage",
                "id": 6,
                "rule": "repeated"
              },
              "emailCount": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              }
            }
          },
          "InstrumentsOnFile": {
            "fields": {
              "error": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "instrument": {
                "type": ".squareup.simple_instrument_store.api.InstrumentSummary",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ExportStatus": {
            "values": {
              "EXPORT_PENDING": 1,
              "EXPORT_IN_PROGRESS": 2,
              "EXPORT_ERRORED": 3,
              "EXPORT_COMPLETE": 4
            }
          },
          "MergeProposalV2": {
            "fields": {
              "duplicateContact1": {
                "type": ".squareup.rolodex.Contact",
                "id": 1,
                "rule": "optional"
              },
              "duplicateContact2": {
                "type": ".squareup.rolodex.Contact",
                "id": 2,
                "rule": "optional"
              },
              "newContact": {
                "type": ".squareup.rolodex.Contact",
                "id": 3,
                "rule": "optional"
              },
              "duplicateContacts": {
                "type": ".squareup.rolodex.Contact",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "DuplicateContactPair": {
            "fields": {
              "duplicateContactToken1": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "duplicateContactToken2": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ContactType": {
            "values": {
              "PRIMARY": 1,
              "OTHER": 2
            }
          },
          "Email": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.ContactType",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "PRIMARY"
                }
              },
              "emailAddress": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "emailId": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "Phone": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.ContactType",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "PRIMARY"
                }
              },
              "phoneNumber": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "phoneId": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "Address": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.ContactType",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "PRIMARY"
                }
              },
              "address": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AttributeSchema": {
            "fields": {
              "version": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "attributeDefinitions": {
                "type": ".squareup.rolodex.AttributeSchema.AttributeDefinition",
                "id": 2,
                "rule": "repeated"
              },
              "attributeKeysInOrder": {
                "type": "string",
                "id": 3,
                "rule": "repeated"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN": 0,
                  "NUMBER": 1,
                  "BOOLEAN": 2,
                  "TEXT": 3,
                  "ENUM": 4,
                  "EMAIL": 5,
                  "PHONE": 6,
                  "ADDRESS": 7,
                  "DATE": 8
                }
              },
              "Visibility": {
                "values": {
                  "VISIBILITY_UNKNOWN": 0,
                  "VISIBILITY_HIDDEN": 1,
                  "VISIBILITY_READ": 2,
                  "VISIBILITY_READ_WRITE": 3
                }
              },
              "AttributeDefinition": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.rolodex.AttributeSchema.Type",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isVisibleInProfile": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isHidden": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "enumAllowMultiple": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "enumValues": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "isDefault": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "isSelectedColumn": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "isConfigurable": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "visibility": {
                    "type": ".squareup.rolodex.AttributeSchema.Visibility",
                    "id": 11,
                    "rule": "optional"
                  },
                  "owner": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "Attribute": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.rolodex.AttributeSchema.Type",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fallbackValue": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isVisibleInProfile": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "boolean": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "text": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "numberValue": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "enumValue": {
                    "type": "string",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "emailValue": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "phoneValue": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "addressValue": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 13,
                    "rule": "optional"
                  },
                  "dateValue": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 14,
                    "rule": "optional"
                  },
                  "number": {
                    "type": "float",
                    "id": 5,
                    "rule": "optional"
                  },
                  "visibility": {
                    "type": ".squareup.rolodex.AttributeSchema.Visibility",
                    "id": 15,
                    "rule": "optional"
                  },
                  "owner": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "ContactSet": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.ContactSetType",
                "id": 1,
                "rule": "optional"
              },
              "contactTokensIncluded": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "groupToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "contactTokensExcluded": {
                "type": "string",
                "id": 4,
                "rule": "repeated"
              },
              "filters": {
                "type": ".squareup.rolodex.Filter",
                "id": 5,
                "rule": "repeated"
              },
              "contactSearchCriteria": {
                "type": ".squareup.rolodex.ContactSet.ContactSearchCriteria",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "ContactSearchCriteria": {
                "fields": {
                  "query": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "conditions": {
                    "type": ".squareup.rolodexdiscovery.service.FilterConditions",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "ContactSetType": {
            "values": {
              "ALL_CONTACTS": 1,
              "INCLUDED_CONTACTS": 2,
              "GROUP": 3,
              "FILTERS": 4,
              "CONTACT_SEARCH_CRITERIA": 5
            }
          },
          "ContactBatchActionStatus": {
            "fields": {
              "totalSuccessCount": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "totalErrorCount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "Filter": {
            "fields": {
              "type": {
                "type": ".squareup.rolodex.Filter.Type",
                "id": 1,
                "rule": "optional"
              },
              "displayName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "allowMultiplesInConjunction": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "groupToken": {
                "type": "string",
                "id": 100,
                "rule": "optional"
              },
              "mgGroupTokens": {
                "type": "string",
                "id": 101,
                "rule": "repeated"
              },
              "xpilydXPayments": {
                "type": "int32",
                "id": 200,
                "rule": "optional"
              },
              "xpilydXPaymentsFieldName": {
                "type": "string",
                "id": 201,
                "rule": "optional"
              },
              "xpilydYDays": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 202,
                "rule": "optional"
              },
              "xpilydYDaysFieldName": {
                "type": "string",
                "id": 203,
                "rule": "optional"
              },
              "xpilydYDaysOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 204,
                "rule": "repeated"
              },
              "lpilydYDays": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 300,
                "rule": "optional"
              },
              "lpilydYDaysOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 301,
                "rule": "repeated"
              },
              "npilydYDays": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 400,
                "rule": "optional"
              },
              "npilydYDaysOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 401,
                "rule": "repeated"
              },
              "rXPayments": {
                "type": "int32",
                "id": 500,
                "rule": "optional"
              },
              "rXPaymentsFieldName": {
                "type": "string",
                "id": 501,
                "rule": "optional"
              },
              "rYDays": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 502,
                "rule": "optional"
              },
              "rYDaysFieldName": {
                "type": "string",
                "id": 503,
                "rule": "optional"
              },
              "rYDaysOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 504,
                "rule": "repeated"
              },
              "catAttributeToken": {
                "type": "string",
                "id": 600,
                "rule": "optional"
              },
              "catAttributeValue": {
                "type": "string",
                "id": 601,
                "rule": "optional"
              },
              "catCondition": {
                "type": ".squareup.rolodex.CustomAttributeText.Condition",
                "id": 602,
                "rule": "optional"
              },
              "caeAttributeToken": {
                "type": "string",
                "id": 700,
                "rule": "optional"
              },
              "caeAttributeValue": {
                "type": "string",
                "id": 701,
                "rule": "optional"
              },
              "caeCondition": {
                "type": ".squareup.rolodex.CustomAttributeEmail.Condition",
                "id": 702,
                "rule": "optional"
              },
              "capAttributeToken": {
                "type": "string",
                "id": 800,
                "rule": "optional"
              },
              "capAttributeValue": {
                "type": "string",
                "id": 801,
                "rule": "optional"
              },
              "capCondition": {
                "type": ".squareup.rolodex.CustomAttributePhone.Condition",
                "id": 802,
                "rule": "optional"
              },
              "caenAttributeToken": {
                "type": "string",
                "id": 900,
                "rule": "optional"
              },
              "caenAttributeValues": {
                "type": "string",
                "id": 901,
                "rule": "repeated"
              },
              "caenCondition": {
                "type": ".squareup.rolodex.CustomAttributeEnum.Condition",
                "id": 902,
                "rule": "optional"
              },
              "caenAttributeOptions": {
                "type": "string",
                "id": 903,
                "rule": "repeated"
              },
              "cabAttributeToken": {
                "type": "string",
                "id": 1000,
                "rule": "optional"
              },
              "cabAttributeValue": {
                "type": "bool",
                "id": 1001,
                "rule": "optional"
              },
              "cabAttributeSelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1002,
                "rule": "optional"
              },
              "cabAttributeOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1003,
                "rule": "repeated"
              },
              "fbSentimentType": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1101,
                "rule": "optional"
              },
              "fbSentimentTypeOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1102,
                "rule": "repeated"
              },
              "sqSearchQuery": {
                "type": "string",
                "id": 1200,
                "rule": "optional"
              },
              "sqFullEmailAddress": {
                "type": "string",
                "id": 1201,
                "rule": "optional"
              },
              "sqFullPhoneNumber": {
                "type": "string",
                "id": 1202,
                "rule": "optional"
              },
              "hcofHasCardOnFile": {
                "type": "bool",
                "id": 1300,
                "rule": "optional"
              },
              "hcofHasCardOnFileSelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1301,
                "rule": "optional"
              },
              "hcofHasCardOnFileOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1302,
                "rule": "repeated"
              },
              "hlHasLoyalty": {
                "type": "bool",
                "id": 1400,
                "rule": "optional"
              },
              "hlHasLoyaltySelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1401,
                "rule": "optional"
              },
              "hlHasLoyaltyOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1402,
                "rule": "repeated"
              },
              "gfGroupToken": {
                "type": "string",
                "id": 1500,
                "rule": "optional"
              },
              "hvlLocations": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1600,
                "rule": "repeated"
              },
              "hvlLocationsOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1601,
                "rule": "repeated"
              },
              "fbv2SentimentType": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1700,
                "rule": "optional"
              },
              "fbv2SentimentTypeFieldName": {
                "type": "string",
                "id": 1701,
                "rule": "optional"
              },
              "fbv2SentimentTypeOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1702,
                "rule": "repeated"
              },
              "fbv2YDaysFieldName": {
                "type": "string",
                "id": 1703,
                "rule": "optional"
              },
              "fbv2YDaysOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1704,
                "rule": "repeated"
              },
              "fbv2YDaysValue": {
                "type": "int64",
                "id": 1705,
                "rule": "optional"
              },
              "fbv2YDaysSelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1706,
                "rule": "optional"
              },
              "agGroupTokens": {
                "type": "string",
                "id": 1800,
                "rule": "repeated"
              },
              "csCreationSourceTypes": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1900,
                "rule": "repeated"
              },
              "csCreationSourceTypesOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 1901,
                "rule": "repeated"
              },
              "iipIsInstantProfile": {
                "type": "bool",
                "id": 2000,
                "rule": "optional"
              },
              "iipIsInstantProfileSelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 2001,
                "rule": "optional"
              },
              "iipIsInstantProfileOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 2002,
                "rule": "repeated"
              },
              "crtBeginTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 2100,
                "rule": "optional"
              },
              "crtEndTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 2101,
                "rule": "optional"
              },
              "uptBeginTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 2200,
                "rule": "optional"
              },
              "uptEndTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 2201,
                "rule": "optional"
              },
              "afiAppId": {
                "type": "string",
                "id": 2300,
                "rule": "optional"
              },
              "afiName": {
                "type": "string",
                "id": 2301,
                "rule": "optional"
              },
              "afiComparator": {
                "type": ".squareup.rolodex.Comparator",
                "id": 2302,
                "rule": "optional"
              },
              "afiValue": {
                "type": "int64",
                "id": 2303,
                "rule": "optional"
              },
              "afdtAppId": {
                "type": "string",
                "id": 2400,
                "rule": "optional"
              },
              "afdtName": {
                "type": "string",
                "id": 2401,
                "rule": "optional"
              },
              "afdtComparator": {
                "type": ".squareup.rolodex.Comparator",
                "id": 2402,
                "rule": "optional"
              },
              "afdtDaysFromNow": {
                "type": "int64",
                "id": 2403,
                "rule": "optional"
              },
              "afdtIgnoreYear": {
                "type": "bool",
                "id": 2404,
                "rule": "optional"
              },
              "afeAppId": {
                "type": "string",
                "id": 2500,
                "rule": "optional"
              },
              "afeName": {
                "type": "string",
                "id": 2501,
                "rule": "optional"
              },
              "afeExists": {
                "type": "bool",
                "id": 2502,
                "rule": "optional"
              },
              "cbfCashBrandFollowing": {
                "type": "bool",
                "id": 2600,
                "rule": "optional"
              },
              "cbfCashBrandFollowingSelection": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 2601,
                "rule": "optional"
              },
              "cbfCashBrandFollowingOptions": {
                "type": ".squareup.rolodex.Filter.Option",
                "id": 2602,
                "rule": "repeated"
              }
            },
            "nested": {
              "Option": {
                "fields": {
                  "value": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "label": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Type": {
                "values": {
                  "SKIPPED": 0,
                  "MANUAL_GROUP": 1,
                  "X_PAYMENTS_IN_LAST_Y_DAYS": 2,
                  "LAST_PAYMENT_IN_LAST_Y_DAYS": 3,
                  "NO_PAYMENT_IN_LAST_Y_DAYS": 4,
                  "REACHABLE_VIA_MARKETING": 5,
                  "CUSTOM_ATTRIBUTE_TEXT": 6,
                  "HAS_CARD_ON_FILE": 7,
                  "CUSTOM_ATTRIBUTE_PHONE": 8,
                  "CUSTOM_ATTRIBUTE_EMAIL": 9,
                  "CUSTOM_ATTRIBUTE_BOOLEAN": 10,
                  "CUSTOM_ATTRIBUTE_ENUM": 11,
                  "FEEDBACK": 12,
                  "SEARCH_QUERY": 13,
                  "HAS_LOYALTY": 14,
                  "GROUP_FILTER": 15,
                  "HAS_VISITED_LOCATION": 16,
                  "FEEDBACK_V2": 17,
                  "ANY_GROUP_FILTER": 18,
                  "CREATION_SOURCE_FILTER": 19,
                  "IS_INSTANT_PROFILE": 20,
                  "CREATED_AT": 21,
                  "UPDATED_AT": 22,
                  "APP_FIELD_INT": 23,
                  "APP_FIELD_DATE": 24,
                  "APP_FIELD_EXISTS": 25,
                  "CASH_BRAND_FOLLOWING": 26
                }
              }
            }
          },
          "CustomAttributeText": {
            "fields": {},
            "nested": {
              "Condition": {
                "values": {
                  "UNKNOWN": 0,
                  "EQUALS": 1
                }
              }
            }
          },
          "CustomAttributeEmail": {
            "fields": {},
            "nested": {
              "Condition": {
                "values": {
                  "UNKNOWN": 0,
                  "EQUALS": 1
                }
              }
            }
          },
          "CustomAttributePhone": {
            "fields": {},
            "nested": {
              "Condition": {
                "values": {
                  "UNKNOWN": 0,
                  "EQUALS": 1
                }
              }
            }
          },
          "CustomAttributeEnum": {
            "nested": {
              "Condition": {
                "values": {
                  "UNKNOWN": 0,
                  "CONTAINS": 1
                }
              }
            }
          },
          "Reminder": {
            "fields": {
              "scheduledAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "Note": {
            "fields": {
              "noteToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "contactToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "body": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "employee": {
                "type": ".squareup.bills.Employee",
                "id": 6,
                "rule": "optional"
              },
              "reminder": {
                "type": ".squareup.rolodex.Reminder",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "Attachment": {
            "fields": {
              "attachmentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "contactToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "fileName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "fileType": {
                "type": ".squareup.rolodex.Attachment.FileType",
                "id": 4,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.rolodex.Attachment.State",
                "id": 5,
                "rule": "optional"
              },
              "contentType": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "fileSizeInBytes": {
                "type": "uint64",
                "id": 7,
                "rule": "optional"
              },
              "employee": {
                "type": ".squareup.bills.Employee",
                "id": 8,
                "rule": "optional"
              },
              "fileContent": {
                "type": "bytes",
                "id": 9,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 10,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 11,
                "rule": "optional"
              }
            },
            "nested": {
              "FileType": {
                "values": {
                  "UNKNOWN_FILE_TYPE": 0,
                  "IMAGE": 1,
                  "PDF": 2
                }
              },
              "State": {
                "values": {
                  "PENDING": 1,
                  "ACTIVE": 2,
                  "DELETED": 3
                }
              }
            }
          },
          "AppField": {
            "fields": {
              "appId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.rolodex.AppField.Type",
                "id": 3,
                "rule": "optional"
              },
              "textValue": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "datetimeValue": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "intValue": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN": 0,
                  "TEXT": 1,
                  "EMAIL_ADDRESS": 2,
                  "PHONE_NUMBER": 3,
                  "DATETIME": 4,
                  "INTEGER": 5
                }
              }
            }
          },
          "GDPRLog": {
            "fields": {
              "gdprRequestType": {
                "type": ".squareup.rolodex.GDPRLog.RequestType",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "contactToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "caseIdentifier": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "requestedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "fulfilledAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "RequestType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ACCESS": 1,
                  "SINGLE_DELETION": 2,
                  "OBJECTION_TO_PROFILING": 3,
                  "CORRECTION": 4,
                  "PORTABILITY": 5,
                  "RESTRICT_PROCESSING": 6,
                  "GLOBAL_DELETION": 7
                }
              }
            }
          },
          "PrivacyRequestType": {
            "values": {
              "ACCESS": 1,
              "SINGLE_DELETION": 2,
              "OBJECTION_TO_PROFILING": 3,
              "CORRECTION": 4,
              "PORTABILITY": 5,
              "RESTRICT_PROCESSING": 6,
              "GLOBAL_DELETION": 7
            }
          },
          "PrivacyFlowType": {
            "values": {
              "GDPR": 1,
              "CCPA": 2,
              "US_PRIVACY_REGULATION": 3
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rolodex?.nested?.RolodexError && !$root.nested?.squareup?.nested?.rolodex?.nested?.RolodexError?.nested?.Code && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactSource && !$root.nested?.squareup?.nested?.rolodex?.nested?.AudienceType && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomerType && !$root.nested?.squareup?.nested?.rolodex?.nested?.Comparator && !$root.nested?.squareup?.nested?.rolodex?.nested?.BuyerFrequencyData && !$root.nested?.squareup?.nested?.rolodex?.nested?.BuyerSummary && !$root.nested?.squareup?.nested?.rolodex?.nested?.Payment && !$root.nested?.squareup?.nested?.rolodex?.nested?.EmailSubscriptions && !$root.nested?.squareup?.nested?.rolodex?.nested?.Contact && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactOptions && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactPaymentPair && !$root.nested?.squareup?.nested?.rolodex?.nested?.Group && !$root.nested?.squareup?.nested?.rolodex?.nested?.GroupV2 && !$root.nested?.squareup?.nested?.rolodex?.nested?.GroupV2?.nested?.Type && !$root.nested?.squareup?.nested?.rolodex?.nested?.GroupOptions && !$root.nested?.squareup?.nested?.rolodex?.nested?.GroupType && !$root.nested?.squareup?.nested?.rolodex?.nested?.RequestedGroupType && !$root.nested?.squareup?.nested?.rolodex?.nested?.AudienceParams && !$root.nested?.squareup?.nested?.rolodex?.nested?.LinkedPaymentCard && !$root.nested?.squareup?.nested?.rolodex?.nested?.LinkedPaymentCards && !$root.nested?.squareup?.nested?.rolodex?.nested?.MerchantOptions && !$root.nested?.squareup?.nested?.rolodex?.nested?.Merchant && !$root.nested?.squareup?.nested?.rolodex?.nested?.SmartGroupSettings && !$root.nested?.squareup?.nested?.rolodex?.nested?.MerchantSettings && !$root.nested?.squareup?.nested?.rolodex?.nested?.Profile && !$root.nested?.squareup?.nested?.rolodex?.nested?.ApplicationFields && !$root.nested?.squareup?.nested?.rolodex?.nested?.ObfuscatedIdentifiers && !$root.nested?.squareup?.nested?.rolodex?.nested?.HeaderType && !$root.nested?.squareup?.nested?.rolodex?.nested?.HeaderDefinition && !$root.nested?.squareup?.nested?.rolodex?.nested?.HeaderDefinition?.nested?.CustomAttributeType && !$root.nested?.squareup?.nested?.rolodex?.nested?.CSVMessage && !$root.nested?.squareup?.nested?.rolodex?.nested?.HeaderSpec && !$root.nested?.squareup?.nested?.rolodex?.nested?.CSVImportState && !$root.nested?.squareup?.nested?.rolodex?.nested?.CSVImportStatus && !$root.nested?.squareup?.nested?.rolodex?.nested?.InstrumentsOnFile && !$root.nested?.squareup?.nested?.rolodex?.nested?.ExportStatus && !$root.nested?.squareup?.nested?.rolodex?.nested?.MergeProposalV2 && !$root.nested?.squareup?.nested?.rolodex?.nested?.DuplicateContactPair && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactType && !$root.nested?.squareup?.nested?.rolodex?.nested?.Email && !$root.nested?.squareup?.nested?.rolodex?.nested?.Phone && !$root.nested?.squareup?.nested?.rolodex?.nested?.Address && !$root.nested?.squareup?.nested?.rolodex?.nested?.AttributeSchema && !$root.nested?.squareup?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Type && !$root.nested?.squareup?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Visibility && !$root.nested?.squareup?.nested?.rolodex?.nested?.AttributeSchema?.nested?.AttributeDefinition && !$root.nested?.squareup?.nested?.rolodex?.nested?.AttributeSchema?.nested?.Attribute && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactSet && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactSet?.nested?.ContactSearchCriteria && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactSetType && !$root.nested?.squareup?.nested?.rolodex?.nested?.ContactBatchActionStatus && !$root.nested?.squareup?.nested?.rolodex?.nested?.Filter && !$root.nested?.squareup?.nested?.rolodex?.nested?.Filter?.nested?.Option && !$root.nested?.squareup?.nested?.rolodex?.nested?.Filter?.nested?.Type && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributeText && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributeText?.nested?.Condition && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributeEmail && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributeEmail?.nested?.Condition && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributePhone && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributePhone?.nested?.Condition && !$root.nested?.squareup?.nested?.rolodex?.nested?.CustomAttributeEnum?.nested?.Condition && !$root.nested?.squareup?.nested?.rolodex?.nested?.Reminder && !$root.nested?.squareup?.nested?.rolodex?.nested?.Note && !$root.nested?.squareup?.nested?.rolodex?.nested?.Attachment && !$root.nested?.squareup?.nested?.rolodex?.nested?.Attachment?.nested?.FileType && !$root.nested?.squareup?.nested?.rolodex?.nested?.Attachment?.nested?.State && !$root.nested?.squareup?.nested?.rolodex?.nested?.AppField && !$root.nested?.squareup?.nested?.rolodex?.nested?.AppField?.nested?.Type && !$root.nested?.squareup?.nested?.rolodex?.nested?.GDPRLog && !$root.nested?.squareup?.nested?.rolodex?.nested?.GDPRLog?.nested?.RequestType && !$root.nested?.squareup?.nested?.rolodex?.nested?.PrivacyRequestType && !$root.nested?.squareup?.nested?.rolodex?.nested?.PrivacyFlowType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RolodexError @ squareup/rolodex/data.proto at 36:1
 */
export const RolodexError = $root.lookupType('squareup.rolodex.RolodexError');
fixType(RolodexError);
Builder.createAndAttachToType(RolodexError);
/**
 * SOURCE Code @ squareup/rolodex/data.proto at 37:3
 */
RolodexError.Code = $root.lookupEnum('squareup.rolodex.RolodexError.Code').values;
/**
 * Next id: 26
 *
 * SOURCE ContactSource @ squareup/rolodex/data.proto at 51:1
 */
export const ContactSource = $root.lookupEnum('squareup.rolodex.ContactSource').values;
/**
 * WARNING: Adding an AudienceType requires a Dashboard code change and deploy. Failure to do so
 * will cause an outage in Directory
 *
 * SOURCE AudienceType @ squareup/rolodex/data.proto at 106:1
 */
export const AudienceType = $root.lookupEnum('squareup.rolodex.AudienceType').values;
/**
 * SOURCE CustomerType @ squareup/rolodex/data.proto at 153:1
 */
export const CustomerType = $root.lookupEnum('squareup.rolodex.CustomerType').values;
/**
 * Used to represent a comparison between values.
 *
 * SOURCE Comparator @ squareup/rolodex/data.proto at 165:1
 */
export const Comparator = $root.lookupEnum('squareup.rolodex.Comparator').values;
/**
 * SOURCE BuyerFrequencyData @ squareup/rolodex/data.proto at 173:1
 */
export const BuyerFrequencyData = $root.lookupType('squareup.rolodex.BuyerFrequencyData');
fixType(BuyerFrequencyData);
Builder.createAndAttachToType(BuyerFrequencyData);
/**
 * Summary of payments made by a contact.
 *
 * SOURCE BuyerSummary @ squareup/rolodex/data.proto at 197:1
 */
export const BuyerSummary = $root.lookupType('squareup.rolodex.BuyerSummary');
fixType(BuyerSummary);
Builder.createAndAttachToType(BuyerSummary);
/**
 * SOURCE Payment @ squareup/rolodex/data.proto at 209:1
 */
export const Payment = $root.lookupType('squareup.rolodex.Payment');
fixType(Payment);
Builder.createAndAttachToType(Payment);
/**
 * SOURCE EmailSubscriptions @ squareup/rolodex/data.proto at 241:1
 */
export const EmailSubscriptions = $root.lookupType('squareup.rolodex.EmailSubscriptions');
fixType(EmailSubscriptions);
Builder.createAndAttachToType(EmailSubscriptions);
/**
 * SOURCE Contact @ squareup/rolodex/data.proto at 246:1
 */
export const Contact = $root.lookupType('squareup.rolodex.Contact');
fixType(Contact);
Builder.createAndAttachToType(Contact);
/**
 * SOURCE ContactOptions @ squareup/rolodex/data.proto at 482:1
 */
export const ContactOptions = $root.lookupType('squareup.rolodex.ContactOptions');
fixType(ContactOptions);
Builder.createAndAttachToType(ContactOptions);
/**
 * SOURCE ContactPaymentPair @ squareup/rolodex/data.proto at 545:1
 */
export const ContactPaymentPair = $root.lookupType('squareup.rolodex.ContactPaymentPair');
fixType(ContactPaymentPair);
Builder.createAndAttachToType(ContactPaymentPair);
/**
 * SOURCE Group @ squareup/rolodex/data.proto at 590:1
 */
export const Group = $root.lookupType('squareup.rolodex.Group');
fixType(Group);
Builder.createAndAttachToType(Group);
/**
 * New Group message related to Grouping & Filtering project. This supports manual groups and
 * smart groups defined as sets of filters.
 *
 * SOURCE GroupV2 @ squareup/rolodex/data.proto at 657:1
 */
export const GroupV2 = $root.lookupType('squareup.rolodex.GroupV2');
fixType(GroupV2, {
  type: {
    required: true
  },
  groupTokenPair: {
    required: true
  },
  merchantToken: {
    required: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GroupV2);
/**
 * SOURCE Type @ squareup/rolodex/data.proto at 658:3
 */
GroupV2.Type = $root.lookupEnum('squareup.rolodex.GroupV2.Type').values;
/**
 * SOURCE GroupOptions @ squareup/rolodex/data.proto at 722:1
 */
export const GroupOptions = $root.lookupType('squareup.rolodex.GroupOptions');
fixType(GroupOptions);
Builder.createAndAttachToType(GroupOptions);
/**
 * SOURCE GroupType @ squareup/rolodex/data.proto at 735:1
 */
export const GroupType = $root.lookupEnum('squareup.rolodex.GroupType').values;
/**
 * SOURCE RequestedGroupType @ squareup/rolodex/data.proto at 741:1
 */
export const RequestedGroupType = $root.lookupType('squareup.rolodex.RequestedGroupType');
fixType(RequestedGroupType);
Builder.createAndAttachToType(RequestedGroupType);
/**
 * Wraps configurable functions and their parameters allowing merchants to configure smart groups.
 *
 * If you want to add a new type of parameterized smart group add a type for that group and add a
 * corresponding extension.
 *
 * The extension corresponds to a function which uses the parameters specified to return a list of
 * contacts.
 *
 * Example:
 * - Loyal: 3+ visits in 6 months, last visit < 6 weeks ago
 * loyalParams := AudienceParam{Type: rolodex.AudienceType_LOYAL}
 * loyalParams.SetExtension(Loyal.GteXVisits, 3)
 * loyalParams.SetExtension(Loyal.InYDays, 6)
 * loyalParams.SetExtension(Loyal.LastVisitLtZDaysAgo, 6)
 *
 * SOURCE AudienceParams @ squareup/rolodex/data.proto at 768:1
 */
export const AudienceParams = $root.lookupType('squareup.rolodex.AudienceParams');
fixType(AudienceParams, {
  type: {
    required: true
  },
  casualExactlyXVisits: {
    required: true
  },
  casualInYDays: {
    required: true
  },
  loyalGteXVisits: {
    required: true
  },
  loyalInYDays: {
    required: true
  },
  loyalLastVisitLtZDaysAgo: {
    required: true
  },
  churnRiskGteXVisits: {
    required: true
  },
  churnRiskInYDays: {
    required: true
  },
  churnRiskLastVisitGtZDaysAgo: {
    required: true
  }
});
Builder.createAndAttachToType(AudienceParams);
/**
 * SOURCE LinkedPaymentCard @ squareup/rolodex/data.proto at 805:1
 */
export const LinkedPaymentCard = $root.lookupType('squareup.rolodex.LinkedPaymentCard');
fixType(LinkedPaymentCard);
Builder.createAndAttachToType(LinkedPaymentCard);
/**
 * SOURCE LinkedPaymentCards @ squareup/rolodex/data.proto at 841:1
 */
export const LinkedPaymentCards = $root.lookupType('squareup.rolodex.LinkedPaymentCards');
fixType(LinkedPaymentCards);
Builder.createAndAttachToType(LinkedPaymentCards);
/**
 * Merchant information
 *
 * SOURCE MerchantOptions @ squareup/rolodex/data.proto at 848:1
 */
export const MerchantOptions = $root.lookupType('squareup.rolodex.MerchantOptions');
fixType(MerchantOptions);
Builder.createAndAttachToType(MerchantOptions);
/**
 * SOURCE Merchant @ squareup/rolodex/data.proto at 871:1
 */
export const Merchant = $root.lookupType('squareup.rolodex.Merchant');
fixType(Merchant);
Builder.createAndAttachToType(Merchant);
/**
 * This controls the Smart Group (Loyal, Casual, Lapsed) definions since they're interrelated.
 *
 * Total Contactable = [min_visits, infinity) in max_days
 * -> for now (10/30/2015) we're keeping this at 2 visits in 6 months and not going to use these
 * settings to calculate billing.
 *
 * Casual = [min_visits, loyal_min_visits) in max_days
 * Loyal = [loyal_min_visits, infinity) in loyal_max_days with one visit in loyal_last_visit_in_days_ago
 * Lapsed = [loyal_min_visits, infinity) in loyal_max_days with no visits in loyal_last_visit_in_days_ago
 *
 * SOURCE SmartGroupSettings @ squareup/rolodex/data.proto at 924:1
 */
export const SmartGroupSettings = $root.lookupType('squareup.rolodex.SmartGroupSettings');
fixType(SmartGroupSettings, {
  minVisits: {
    required: true
  },
  maxDays: {
    required: true
  },
  loyalMinVisits: {
    required: true
  },
  loyalMaxDays: {
    required: true
  },
  loyalLastVisitInDaysAgo: {
    required: true
  }
});
Builder.createAndAttachToType(SmartGroupSettings);
/**
 * SOURCE MerchantSettings @ squareup/rolodex/data.proto at 953:1
 */
export const MerchantSettings = $root.lookupType('squareup.rolodex.MerchantSettings');
fixType(MerchantSettings, {
  enableAutomaticContactCreation: {
    required: true
  }
});
Builder.createAndAttachToType(MerchantSettings);
/**
 * SOURCE Profile @ squareup/rolodex/data.proto at 975:1
 */
export const Profile = $root.lookupType('squareup.rolodex.Profile');
fixType(Profile);
Builder.createAndAttachToType(Profile);
/**
 * Application defined fields. e.g. Appointments contact specific notification settings.
 * A flat map of application fields. Ideally should follow the format <application>_<field>,
 * but that's just a suggestion. If the format cuts across a couple applications but isn't
 * universal enough to go in Profile, don't worry about it.
 *
 * Steps if you add a field here:
 * (1) Modify ApplicationFields struct in db/application_fields.go to contain new field
 * (2) Modify conversion/merge functions in models/application_fields.go
 * (3) Add test for new field in models/application_fields_test.go
 *
 * NOTE: Update semantics different than for profile. Only updates application_fields
 * if the value of the field is non-nil and contact_options.include_application_fields = true.
 * There is no way to delete a field in the application fields, to clear the field
 * set the value to Zero value of that type.
 * e.g. bool - false
 * int - 0
 * string - ""
 * slice - []
 * object - empty object where all fields are nil
 * WARNING: This implies that once a field exists the application the client can only clear
 * the field. There's no way to remove the field in the database. The client determines to
 * show/not show the field according to its logic.
 *
 * SOURCE ApplicationFields @ squareup/rolodex/data.proto at 1047:1
 */
export const ApplicationFields = $root.lookupType('squareup.rolodex.ApplicationFields');
fixType(ApplicationFields);
Builder.createAndAttachToType(ApplicationFields);
/**
 * SOURCE ObfuscatedIdentifiers @ squareup/rolodex/data.proto at 1055:1
 */
export const ObfuscatedIdentifiers = $root.lookupType('squareup.rolodex.ObfuscatedIdentifiers');
fixType(ObfuscatedIdentifiers);
Builder.createAndAttachToType(ObfuscatedIdentifiers);
/**
 * CSV Import Messages
 *
 * SOURCE HeaderType @ squareup/rolodex/data.proto at 1068:1
 */
export const HeaderType = $root.lookupEnum('squareup.rolodex.HeaderType').values;
/**
 * SOURCE HeaderDefinition @ squareup/rolodex/data.proto at 1094:1
 */
export const HeaderDefinition = $root.lookupType('squareup.rolodex.HeaderDefinition');
fixType(HeaderDefinition);
Builder.createAndAttachToType(HeaderDefinition);
/**
 * SOURCE CustomAttributeType @ squareup/rolodex/data.proto at 1095:3
 */
HeaderDefinition.CustomAttributeType = $root.lookupEnum('squareup.rolodex.HeaderDefinition.CustomAttributeType').values;
/**
 * CSVMessage is used to carry error message when handling the csv file.
 *
 * SOURCE CSVMessage @ squareup/rolodex/data.proto at 1123:1
 */
export const CSVMessage = $root.lookupType('squareup.rolodex.CSVMessage');
fixType(CSVMessage);
Builder.createAndAttachToType(CSVMessage);
/**
 * SOURCE HeaderSpec @ squareup/rolodex/data.proto at 1136:1
 */
export const HeaderSpec = $root.lookupType('squareup.rolodex.HeaderSpec');
fixType(HeaderSpec);
Builder.createAndAttachToType(HeaderSpec);
/**
 * CSVImportState communicates to Dashboard the state of a CSV import. Note that it only communicates what
 * is important to Dashboard, namely whether or not an import has finished. This is explicitly different and
 * more general than the actual state of an import, and so, CSVImportState contains fewer states than the
 * corresponding ImportJobState.
 *
 * SOURCE CSVImportState @ squareup/rolodex/data.proto at 1153:1
 */
export const CSVImportState = $root.lookupEnum('squareup.rolodex.CSVImportState').values;
/**
 * SOURCE CSVImportStatus @ squareup/rolodex/data.proto at 1162:1
 */
export const CSVImportStatus = $root.lookupType('squareup.rolodex.CSVImportStatus');
fixType(CSVImportStatus);
Builder.createAndAttachToType(CSVImportStatus);
/**
 * SOURCE InstrumentsOnFile @ squareup/rolodex/data.proto at 1190:1
 */
export const InstrumentsOnFile = $root.lookupType('squareup.rolodex.InstrumentsOnFile');
fixType(InstrumentsOnFile);
Builder.createAndAttachToType(InstrumentsOnFile);
/**
 * Export
 *
 * SOURCE ExportStatus @ squareup/rolodex/data.proto at 1200:1
 */
export const ExportStatus = $root.lookupEnum('squareup.rolodex.ExportStatus').values;
/**
 * In MergeProposalV2 we list duplication in the form of contact pair
 *
 * SOURCE MergeProposalV2 @ squareup/rolodex/data.proto at 1241:1
 */
export const MergeProposalV2 = $root.lookupType('squareup.rolodex.MergeProposalV2');
fixType(MergeProposalV2, {
  newContact: {
    required: true
  },
  duplicateContacts: {
    required: true
  }
});
Builder.createAndAttachToType(MergeProposalV2);
/**
 * In MergeProposalV2 we list duplication in the form of contact pair
 *
 * SOURCE DuplicateContactPair @ squareup/rolodex/data.proto at 1253:1
 */
export const DuplicateContactPair = $root.lookupType('squareup.rolodex.DuplicateContactPair');
fixType(DuplicateContactPair, {
  duplicateContactToken1: {
    required: true
  },
  duplicateContactToken2: {
    required: true
  }
});
Builder.createAndAttachToType(DuplicateContactPair);
/**
 * SOURCE ContactType @ squareup/rolodex/data.proto at 1305:1
 */
export const ContactType = $root.lookupEnum('squareup.rolodex.ContactType').values;
/**
 * SOURCE Email @ squareup/rolodex/data.proto at 1311:1
 */
export const Email = $root.lookupType('squareup.rolodex.Email');
fixType(Email);
Builder.createAndAttachToType(Email);
/**
 * SOURCE Phone @ squareup/rolodex/data.proto at 1318:1
 */
export const Phone = $root.lookupType('squareup.rolodex.Phone');
fixType(Phone);
Builder.createAndAttachToType(Phone);
/**
 * SOURCE Address @ squareup/rolodex/data.proto at 1325:1
 */
export const Address = $root.lookupType('squareup.rolodex.Address');
fixType(Address);
Builder.createAndAttachToType(Address);
/**
 * Custom attributes in directory
 *
 * SOURCE AttributeSchema @ squareup/rolodex/data.proto at 1337:1
 */
export const AttributeSchema = $root.lookupType('squareup.rolodex.AttributeSchema');
fixType(AttributeSchema);
Builder.createAndAttachToType(AttributeSchema);
/**
 * If for any reason an enum name needs to change, an associated change in
 * customers-fe type converters needs to be made.
 *
 * SOURCE Type @ squareup/rolodex/data.proto at 1340:3
 */
AttributeSchema.Type = $root.lookupEnum('squareup.rolodex.AttributeSchema.Type').values;
/**
 * SOURCE Visibility @ squareup/rolodex/data.proto at 1352:3
 */
AttributeSchema.Visibility = $root.lookupEnum('squareup.rolodex.AttributeSchema.Visibility').values;
/**
 * SOURCE AttributeDefinition @ squareup/rolodex/data.proto at 1359:3
 */
AttributeSchema.AttributeDefinition = $root.lookupType('squareup.rolodex.AttributeSchema.AttributeDefinition');
fixType(AttributeSchema.AttributeDefinition);
Builder.createAndAttachToType(AttributeSchema.AttributeDefinition);
/**
 * SOURCE Attribute @ squareup/rolodex/data.proto at 1393:3
 */
AttributeSchema.Attribute = $root.lookupType('squareup.rolodex.AttributeSchema.Attribute');
fixType(AttributeSchema.Attribute);
Builder.createAndAttachToType(AttributeSchema.Attribute);
/**
 * ContactSet represents a set of contacts in directory
 *
 * SOURCE ContactSet @ squareup/rolodex/data.proto at 1429:1
 */
export const ContactSet = $root.lookupType('squareup.rolodex.ContactSet');
fixType(ContactSet, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(ContactSet);
/**
 * SOURCE ContactSearchCriteria @ squareup/rolodex/data.proto at 1444:3
 */
ContactSet.ContactSearchCriteria = $root.lookupType('squareup.rolodex.ContactSet.ContactSearchCriteria');
fixType(ContactSet.ContactSearchCriteria);
Builder.createAndAttachToType(ContactSet.ContactSearchCriteria);
/**
 * SOURCE ContactSetType @ squareup/rolodex/data.proto at 1455:1
 */
export const ContactSetType = $root.lookupEnum('squareup.rolodex.ContactSetType').values;
/**
 * ContactBatchActionStatus is used in batch contact action endpoints
 *
 * SOURCE ContactBatchActionStatus @ squareup/rolodex/data.proto at 1464:1
 */
export const ContactBatchActionStatus = $root.lookupType('squareup.rolodex.ContactBatchActionStatus');
fixType(ContactBatchActionStatus);
Builder.createAndAttachToType(ContactBatchActionStatus);
/**
 * Filter uses nested protobuf extensions to mimic inheritance in messages. This is
 * the same approach as the cedas event, and has proven to be a tested and effective
 * cross platoform approach.
 *
 * To use: define a new filter type and the corresponding extension which then will
 * allow you to instatiate a filter by specifying the type and setting the corresponding
 * fields in the extension.
 *
 * SOURCE Filter @ squareup/rolodex/data.proto at 1478:1
 */
export const Filter = $root.lookupType('squareup.rolodex.Filter');
fixType(Filter, {
  type: {
    required: true
  },
  mgGroupTokens: {
    required: true
  },
  xpilydXPayments: {
    required: true
  },
  xpilydYDays: {
    required: true
  },
  lpilydYDays: {
    required: true
  },
  npilydYDays: {
    required: true
  },
  rXPayments: {
    required: true
  },
  rYDays: {
    required: true
  },
  catAttributeToken: {
    required: true
  },
  catAttributeValue: {
    required: true
  },
  caeAttributeToken: {
    required: true
  },
  caeAttributeValue: {
    required: true
  },
  capAttributeToken: {
    required: true
  },
  capAttributeValue: {
    required: true
  },
  caenAttributeToken: {
    required: true
  },
  caenAttributeValues: {
    required: true
  },
  cabAttributeToken: {
    required: true
  },
  fbSentimentType: {
    required: true
  },
  gfGroupToken: {
    required: true
  },
  hvlLocations: {
    required: true
  },
  fbv2SentimentType: {
    required: true
  },
  agGroupTokens: {
    required: true
  },
  csCreationSourceTypes: {
    required: true
  },
  afiAppId: {
    notEmpty: true
  },
  afiName: {
    notEmpty: true
  },
  afdtAppId: {
    notEmpty: true
  },
  afdtName: {
    notEmpty: true
  },
  afeAppId: {
    notEmpty: true
  },
  afeName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Filter);
/**
 * SOURCE Option @ squareup/rolodex/data.proto at 1481:3
 */
Filter.Option = $root.lookupType('squareup.rolodex.Filter.Option');
fixType(Filter.Option, {
  value: {
    required: true
  }
});
Builder.createAndAttachToType(Filter.Option);
/**
 * SOURCE Type @ squareup/rolodex/data.proto at 1489:3
 */
Filter.Type = $root.lookupEnum('squareup.rolodex.Filter.Type').values;
/**
 * cat = CustomAttributeText
 *
 * SOURCE CustomAttributeText @ squareup/rolodex/data.proto at 1605:1
 */
export const CustomAttributeText = $root.lookupType('squareup.rolodex.CustomAttributeText');
fixType(CustomAttributeText);
Builder.createAndAttachToType(CustomAttributeText);
/**
 * SOURCE Condition @ squareup/rolodex/data.proto at 1606:3
 */
CustomAttributeText.Condition = $root.lookupEnum('squareup.rolodex.CustomAttributeText.Condition').values;
/**
 * cae = CustomAttributeEmail
 *
 * SOURCE CustomAttributeEmail @ squareup/rolodex/data.proto at 1619:1
 */
export const CustomAttributeEmail = $root.lookupType('squareup.rolodex.CustomAttributeEmail');
fixType(CustomAttributeEmail);
Builder.createAndAttachToType(CustomAttributeEmail);
/**
 * SOURCE Condition @ squareup/rolodex/data.proto at 1620:3
 */
CustomAttributeEmail.Condition = $root.lookupEnum('squareup.rolodex.CustomAttributeEmail.Condition').values;
/**
 * cap = CustomAttributePhone
 *
 * SOURCE CustomAttributePhone @ squareup/rolodex/data.proto at 1633:1
 */
export const CustomAttributePhone = $root.lookupType('squareup.rolodex.CustomAttributePhone');
fixType(CustomAttributePhone);
Builder.createAndAttachToType(CustomAttributePhone);
/**
 * SOURCE Condition @ squareup/rolodex/data.proto at 1634:3
 */
CustomAttributePhone.Condition = $root.lookupEnum('squareup.rolodex.CustomAttributePhone.Condition').values;
/**
 * caen = CustomAttributeEnum
 *
 * SOURCE CustomAttributeEnum @ squareup/rolodex/data.proto at 1647:1
 */
export const CustomAttributeEnum = {};
/**
 * SOURCE Condition @ squareup/rolodex/data.proto at 1648:3
 */
CustomAttributeEnum.Condition = $root.lookupEnum('squareup.rolodex.CustomAttributeEnum.Condition').values;
/**
 * SOURCE Reminder @ squareup/rolodex/data.proto at 1956:1
 */
export const Reminder = $root.lookupType('squareup.rolodex.Reminder');
fixType(Reminder, {
  scheduledAt: {
    required: true
  }
});
Builder.createAndAttachToType(Reminder);
/**
 * Note decoupled from the CEDAS event proto. Has support for reminders feature.
 * Once CRM-1440 is complete, this proto will be the only note proto.
 *
 * SOURCE Note @ squareup/rolodex/data.proto at 1963:1
 */
export const Note = $root.lookupType('squareup.rolodex.Note');
fixType(Note, {
  noteToken: {
    notEmpty: true
  },
  merchantToken: {
    notEmpty: true
  },
  contactToken: {
    notEmpty: true
  },
  body: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Note);
/**
 * SOURCE Attachment @ squareup/rolodex/data.proto at 1978:1
 */
export const Attachment = $root.lookupType('squareup.rolodex.Attachment');
fixType(Attachment, {
  attachmentToken: {
    notEmpty: true
  },
  contactToken: {
    notEmpty: true
  },
  fileName: {
    notEmpty: true
  },
  fileType: {
    required: true
  },
  state: {
    required: true
  },
  contentType: {
    notEmpty: true
  },
  fileSizeInBytes: {
    required: true
  }
});
Builder.createAndAttachToType(Attachment);
/**
 * [Read Only] file_type is for general data type. Client can change behavior
 * based on this information.
 * * e.g. IMAGE is displayed on modal dialog, PDF is displayed on new Web Browser tab
 *
 * SOURCE FileType @ squareup/rolodex/data.proto at 1990:3
 */
Attachment.FileType = $root.lookupEnum('squareup.rolodex.Attachment.FileType').values;
/**
 * [Read Only] Rolodex returns ACTIVE state Attachments only.
 *
 * SOURCE State @ squareup/rolodex/data.proto at 1998:3
 */
Attachment.State = $root.lookupEnum('squareup.rolodex.Attachment.State').values;
/**
 * When using AppField to integrate with directory, several steps should be taken:
 * - update app_field_definition table to set app_id, type, name and is_unique etc. for an app field.
 * - set how to treat conflicting data when merging contacts
 *
 * SOURCE AppField @ squareup/rolodex/data.proto at 2032:1
 */
export const AppField = $root.lookupType('squareup.rolodex.AppField');
fixType(AppField, {
  appId: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AppField);
/**
 * SOURCE Type @ squareup/rolodex/data.proto at 2033:3
 */
AppField.Type = $root.lookupEnum('squareup.rolodex.AppField.Type').values;
/**
 * GDPRLog is to represent an audit log saved in rolodex's database. All
 * the fields are read-only, i.e., prepared by rolodex.
 *
 * SOURCE GDPRLog @ squareup/rolodex/data.proto at 2203:1
 */
export const GDPRLog = $root.lookupType('squareup.rolodex.GDPRLog');
fixType(GDPRLog, {
  gdprRequestType: {
    required: true
  },
  merchantToken: {
    notEmpty: true
  },
  contactToken: {
    notEmpty: true
  },
  caseIdentifier: {
    notEmpty: true
  },
  requestedAt: {
    required: true
  },
  fulfilledAt: {
    required: true
  }
});
Builder.createAndAttachToType(GDPRLog);
/**
 * SOURCE RequestType @ squareup/rolodex/data.proto at 2204:3
 */
GDPRLog.RequestType = $root.lookupEnum('squareup.rolodex.GDPRLog.RequestType').values;
/**
 * Privacy Request Type specifies the type of privacy action for a request.
 *
 * SOURCE PrivacyRequestType @ squareup/rolodex/data.proto at 2239:1
 */
export const PrivacyRequestType = $root.lookupEnum('squareup.rolodex.PrivacyRequestType').values;
/**
 * Privacy Flow Type specifies the privacy flow for a request.
 *
 * SOURCE PrivacyFlowType @ squareup/rolodex/data.proto at 2250:1
 */
export const PrivacyFlowType = $root.lookupEnum('squareup.rolodex.PrivacyFlowType').values;